/** Wait for a typing pause before calling resolve-email. */
export const RESOLVE_DEBOUNCE_MS = 750;

/**
 * Matches msuite_api resolve-email Joi: local@domain (no spaces).
 * @param {string} value
 * @returns {boolean}
 */
export function isEmailReadyForResolve(value) {
  const trimmed = String(value || "").trim();
  return /^[^\s@]+@[^\s@]+$/.test(trimmed);
}

/**
 * Enough structure to debounce-resolve while typing (domain + TLD started).
 * Avoids API calls on "user@" or "user@accoc" before the address is complete.
 * @param {string} value
 * @returns {boolean}
 */
export function isEmailReadyForDebouncedResolve(value) {
  const trimmed = String(value || "").trim();
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(trimmed);
}
